// extracted by mini-css-extract-plugin
export default {"manage-inactive-clients-grid-popup-client-name":"inactive-clients-grid_manage-inactive-clients-grid-popup-client-name__9Tybx"};